import { storyblokEditable as sbEdit, } from '@storyblok/js';
/**
 * Creates options object for Storyblok editable elements
 */
const createEditableOptions = (value) => {
    const options = sbEdit(value);
    return options['data-blok-c']
        ? {
            'data-blok-c': options['data-blok-c'],
            'data-blok-uid': options['data-blok-uid'],
            'className': 'storyblok__outline',
        }
        : null;
};
/**
 * Applies Storyblok editable attributes to a DOM node
 */
const applyEditableOptions = (node, options) => {
    if (!options) {
        return;
    }
    node.setAttribute('data-blok-c', options['data-blok-c']);
    node.setAttribute('data-blok-uid', options['data-blok-uid']);
    node.classList.add(options.className);
};
/**
 * Svelte action to make a component editable in Storyblok
 */
export const storyblokEditable = (node, value) => {
    const updateDom = (value) => {
        const options = createEditableOptions(value);
        if (options) {
            applyEditableOptions(node, options);
        }
    };
    updateDom(value);
    return {
        update: updateDom,
    };
};
export { getComponent, getStoryblokApi, storyblokInit, } from './storyblok-store';
/**
 * @deprecated Use getStoryblokApi() instead. This will be removed in a next major version.
 */
export { getStoryblokApi as useStoryblokApi } from './storyblok-store';
